// Authentication Pages

export default [{
        params: {
            path: "/banner/1",
            name: "Home",
        },
        defaultComponentPath: "Pages/Home",
        navs: true,
    },

    {
        params: {
            name: "login",
            path: "/login",
            meta: { layout: "full" },
        },
        defaultComponentPath: "Pages/auth/login"
    },

    //field project
    {
        params: {
            name: "project_management/Field_project",
            path: "/project_management/field_project",
        },
        defaultComponentPath: "Pages/project_management/Field_project",
        navs: true,
    },
    {
        params: {
            name: "Add_new_fieldProject",
            path: "/project_management/field_project/add_fieldProject",
        },
        defaultComponentPath: "Pages/field_project/Add_new_fieldProject",
        navs: true,
    },
    {
        params: {
            path: "/project_management/field_project/edit_fieldProject/:id",
            name: "Edit_fieldProject",
        },
        defaultComponentPath: "Pages/field_project/Edit_fieldProject",
        navs: true,
    },
    //project
    {
        params: {
            name: "project_management/Projects",
            path: "/project_management/project",
        },
        defaultComponentPath: "Pages/project_management/Projects",
        navs: true,
    },
    {
        params: {
            name: "Add_project",
            path: "/project_management/project/add_project",
        },
        defaultComponentPath: "Pages/project/Add_project",
        navs: true,
    },
    {
        params: {
            name: "Edit_project",
            path: "/project_management/project/edit_project/:id",
        },
        defaultComponentPath: "Pages/project/Edit_project",
        navs: true,
    },
    //tag
    {
        params: {
            name: "project_management/Tags",
            path: "/project_management/tags",
        },
        defaultComponentPath: "Pages/project_management/Tags",
        navs: true,
    },
    {
        params: {
            name: "AddNewTags",
            path: "/project_management/tags/add_tag",
        },
        defaultComponentPath: "Pages/tag/AddNewTags",
        navs: true,
    },
    {
        params: {
            name: "EditTags",
            path: "/project_management/tags/edit_tag/:id",
        },
        defaultComponentPath: "Pages/tag/EditTags",
        navs: true,
    },
    //partner
    {
        params: {
            name: "Partner",
            path: "/partner",
        },
        defaultComponentPath: "Pages/Partner",
        navs: true,
    },
    {
        params: {
            name: "Add_partner",
            path: "/partner/add_partner",
        },
        defaultComponentPath: "Pages/partner/Add_partner",
        navs: true,
    },
    {
        params: {
            name: "Edit_partner",
            path: "/partner/edit_partner/:id",
        },
        defaultComponentPath: "Pages/partner/Edit_partner",
        navs: true,
    },
    //news
    {
        params: {
            name: "News",
            path: "/news",
        },
        defaultComponentPath: "Pages/News",
        navs: true,
    },
    {
        params: {
            name: "Add_news",
            path: "/news/add_news",
        },
        defaultComponentPath: "Pages/news/Add_news",
        navs: true,
    },
    {
        params: {
            name: "Edit_news",
            path: "/news/edit_news/:id",
        },
        defaultComponentPath: "Pages/news/Edit_news",
        navs: true,
    },
    //position
    {
        params: {
            name: "career_management/Position",
            path: "/career_management/position",
        },
        defaultComponentPath: "Pages/career_management/Position",
        navs: true,
    },
    //career
    {
        params: {
            name: "career_management/Career",
            path: "/career_management/career",
        },
        defaultComponentPath: "Pages/career_management/Career",
        navs: true,
    },
    {
        params: {
            name: "Add_career",
            path: "/career_management/career/add_career",
        },
        defaultComponentPath: "Pages/career/Add_career",
        navs: true,
    },
    {
        params: {
            name: "Edit_career",
            path: "/career_management/career/edit_career/:id",
        },
        defaultComponentPath: "Pages/career/Edit_career",
        navs: true,
    },
    //portfolio
    {
        params: {
            name: "Portfolio",
            path: "/portfolio",
        },
        defaultComponentPath: "Pages/Portfolio",
        navs: true,
    },
    //contact
    {
        params: {
            name: "Contact",
            path: "/contact",
        },
        defaultComponentPath: "Pages/Contact",
        navs: true,
    },
    //Consultation form
    {
        params: {
            name: "ConsultationForm",
            path: "/consultationForm",
        },
        defaultComponentPath: "Pages/ConsultationForm",
        navs: true,
    },
    //process
    {
        params: {
            name: "Process",
            path: "/process",
        },
        defaultComponentPath: "Pages/Process",
        navs: true,
    },
    {
        params: {
            name: "Add_process",
            path: "/process/add_process",
        },
        defaultComponentPath: "Pages/process/Add_process",
        navs: true,
    },
    {
        params: {
            name: "Edit_process",
            path: "/process/edit_process/:id",
        },
        defaultComponentPath: "Pages/process/Edit_process",
        navs: true,
    },
    //service
    {
        params: {
            name: "Service",
            path: "/service",
        },
        defaultComponentPath: "Pages/Service",
        navs: true,
    },
    {
        params: {
            name: "Addnew_service",
            path: "/service/add_service",
        },
        defaultComponentPath: "Pages/service/Addnew_service",
        navs: true,
    },
    {
        params: {
            name: "Edit_service",
            path: "/service/edit_service/:id",
        },
        defaultComponentPath: "Pages/service/Edit_service",
        navs: true,
    },
    //technology
    {
        params: {
            name: "Technology",
            path: "/technology",
        },
        defaultComponentPath: "Pages/Technology",
        navs: true,
    },
    {
        params: {
            name: "Addnew_tech",
            path: "/technology/add_technology",
        },
        defaultComponentPath: "Pages/technology/Addnew_tech",
        navs: true,
    },
    {
        params: {
            name: "Edit_tech",
            path: "/technology/edit_technology/:id",
        },
        defaultComponentPath: "Pages/technology/Edit_tech",
        navs: true,
    },
    //cv
    {
        params: {
            name: "CV",
            path: "/cv",
        },
        defaultComponentPath: "Pages/CV",
        navs: true,
    },
    {
        params: {
            name: "CV_detail",
            path: "/cv/:id",
        },
        defaultComponentPath: "Pages/cv/CV_detail",
        navs: true,
    },
    {
        params: {
            path: "*",
            name: "PageNotFound",
            meta: { layout: "full" },
        },
        defaultComponentPath: "Pages/Errors/Error404",
    },
];
